/**
 * Universe Vibe Controls Component
 * 
 * UI for selecting constellation theme and toggling reduce motion / power saver.
 */

import React from "react";
import { UNIVERSE_THEMES } from "./universeThemes";

export default function UniverseVibeControls({ prefs, setPrefs }) {
  const themeIds = ["classic", "living", "neon", "living_neon"];

  return (
    <div className="w-full rounded-2xl border border-gray-800 bg-black/70 p-3">
      <div className="flex items-center justify-between mb-2">
        <div className="text-white font-semibold">Vibe</div>
        <div className="text-xs text-gray-300">Choose your comfort</div>
      </div>

      {/* Theme Selection */}
      <div className="grid grid-cols-4 gap-2">
        {themeIds.map((id) => {
          const active = prefs.theme === id;
          return (
            <button
              key={id}
              onClick={() => setPrefs((p) => ({ ...p, theme: id }))}
              className={[
                "px-2 py-2 rounded-xl text-xs font-semibold transition border",
                active
                  ? "bg-white text-black border-white"
                  : "bg-gray-900/60 text-gray-200 border-gray-800 hover:bg-gray-800/70",
              ].join(" ")}
              aria-pressed={active}
            >
              {UNIVERSE_THEMES[id].label}
            </button>
          );
        })}
      </div>

      {/* Toggles */}
      <div className="mt-3 flex items-center justify-between gap-3">
        <label className="flex items-center gap-2 text-sm text-gray-200 select-none cursor-pointer">
          <input
            type="checkbox"
            checked={prefs.reduceMotion}
            onChange={(e) => setPrefs((p) => ({ ...p, reduceMotion: e.target.checked }))}
            className="cursor-pointer"
          />
          Reduce motion
        </label>

        <label className="flex items-center gap-2 text-sm text-gray-200 select-none cursor-pointer">
          <input
            type="checkbox"
            checked={prefs.powerSaver}
            onChange={(e) => setPrefs((p) => ({ ...p, powerSaver: e.target.checked }))}
            className="cursor-pointer"
          />
          Power saver
        </label>
      </div>
    </div>
  );
}
